import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredError, requiredMessage } from '@/utils/zodUtils';

export const ValidationSchema = (t: GetTextIdTranslationType) =>
  z.object({
    confirmation: z.boolean(requiredError(t)).refine((val) => val === true, requiredMessage(t)),
  });
